/**
 * Base options for every plugin
 */
export interface PluginOptions
{
}